import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {InspectionTypeDocumentTitle} from 'src/pages/Modules/Inspections/shared/inspectionTypeHelpers';
import {InspectionTypeForm} from 'src/pages/Modules/Inspections/shared/InspectionTypeForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const InspectionTypeEditPage = () => {
  useSetDocumentTitle(InspectionTypeDocumentTitle);
  const {inspectionTypeId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Inspections}>
      <InspectionTypeForm id={Number(inspectionTypeId)} mode="edit" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.InspectionTypesEdit(':inspectionTypeId'),
  element: <InspectionTypeEditPage />,
  module: ModuleEnum.Inspections,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
